import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Logger } from './logger';

@Injectable()
export class LoggingErrorHandler implements ErrorHandler {
  private _loggerVal?: Logger;

  private get logger() {
    if (this._loggerVal != null) {
      return this._loggerVal;
    }
    this._loggerVal = this._injector.get(Logger);
    return this._loggerVal;
  }
  constructor(private readonly _injector: Injector) {}
  public handleError(error: any): void {
    if (this.logger != null) {
      this.logger.error(error);
    }
  }
}
